import Loadable from '../../../../../components/loadable';

export default Loadable(() =>
  import(
    /* webpackChunkName: "business-showcase-3d-viewer-playground" */ './index'
  )
);
